import { EntityProfileType } from "@common/types/entity";

export const entityTypeV2Labels = {
    [EntityProfileType.C_CORP]: "C Corporation",
    [EntityProfileType.SMLLC]: "LLC (single owner)",
    [EntityProfileType.MMLLC]: "LLC (multiple owners)",
    [EntityProfileType.NO_LEGAL_ENTITY]: "I don't have a US legal entity",
    [EntityProfileType.PARTNERSHIP]: "Partnership (including LLPs)",
    [EntityProfileType.S_CORP]: "S Corporation",
    [EntityProfileType.SOLE_PROPRIETORSHIP]: "Sole Proprietorship",
} as const satisfies Record<EntityProfileType, string>;
